angular.module('invoice')
    .component('invoiceProjectList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/invoice-project/list.html',
        controller: function ($scope, $state, $stateParams, $httpParamSerializer, Principal, InvoiceProjectService, InvoiceProjectConst, InvoiceService) {
            this.reset = () => this.filters = {}
            this.InvoiceService = InvoiceService
            this.InvoiceProjectService = InvoiceProjectService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_INVOICE_SETTINGS_WRITE'])
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-project-batch/export?" + $httpParamSerializer(paramsAll)
            }
            $scope.$on(InvoiceProjectConst.eventUpdate, () => $state.reload())
        }
    })
